import comp from "./Prompt";
export default comp;
